import React from 'react';
import PropTypes from 'prop-types';
import { StatusBadge } from '@gsa/afp-component-library';
import { SOLICITATION_STATUS_BADGE_VARIANT_MAP } from '../constants';

function SolicitationStatusBadge({ status, ...restProps }) {
  return (
    <StatusBadge
      {...restProps}
      variant={SOLICITATION_STATUS_BADGE_VARIANT_MAP[status]}
    >
      {status}
    </StatusBadge>
  );
}

SolicitationStatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
};

export default SolicitationStatusBadge;
